import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { type RichTranslationValues } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '../RichText';

export interface LegalParagraphProps {
  readonly className?: string | undefined;
  readonly indent?: 'single' | 'double';
  readonly tx: MessageKey;
  readonly values?: RichTranslationValues | undefined;
}

const LegalParagraph = ({
  className = '',
  indent,
  tx: text,
  values,
}: LegalParagraphProps) => {
  return (
    <Typography
      Element="p"
      className={cx(
        {
          'ml-4': indent === 'single',
          'ml-8': indent === 'double',
        },
        className,
      )}
    >
      <RichText messageKey={text} tValues={values} />
    </Typography>
  );
};

export default LegalParagraph;
